import React, { useState } from 'react';
import { Modal, Form, Select, message } from 'antd';
import { orderAuditApi } from '../../../../services/process/order-audit';
import { useStaffMap } from '../../../../services/store/organization.store';
import { MergedOrder } from '../../../../types/process/order';

export interface TransferOrderModalProps {
  visible: boolean;
  order?: MergedOrder | null;
  orders?: MergedOrder[];
  actionType?: 'transfer' | 'dispatch_d_class';
  onCancel: () => void;
  onSuccess: () => void;
}

const TransferOrderModal: React.FC<TransferOrderModalProps> = ({ visible, order, orders, actionType = 'transfer', onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { staffMap } = useStaffMap();

  const handleSubmit = async () => {
    const targetOrders = orders || (order ? [order] : []);
    if (targetOrders.length === 0) return;
    try {
      const values = await form.validateFields();
      setLoading(true);
      const orderNos = targetOrders.map(o => o.order.orderNo);
      if (actionType === 'dispatch_d_class') {
        const { orderApi } = await import('../../../../services/process/order');
        const { OperationAction } = await import('../../../../types/process/operation-log');
        await orderApi.batchChangeStatus(orderNos, OperationAction.DispatchDClass, { auditId: values.targetId });
        message.success('指派成功');
      } else {
        await orderAuditApi.transfer(orderNos, values.targetId);
        message.success('转单成功');
      }
      onSuccess();
    } catch (error: any) {
      if (error?.errorFields) return;
      message.error(error.response?.data?.message || error.message || '操作失败');
    } finally {
      setLoading(false);
    }
  };

  const staffOptions = Array.from(staffMap.values()).map(staff => ({
    label: staff.name || staff.username || String(staff.id),
    value: staff.id,
  }));

  return (
    <Modal
      title={actionType === 'dispatch_d_class' ? '指派审核' : '转单'}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="targetId"
          label="目标审核人"
          rules={[{ required: true, message: '请选择目标审核人' }]}
        >
          <Select
            showSearch
            placeholder="请选择转单目标审核人"
            optionFilterProp="label"
            options={staffOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TransferOrderModal;
